import * as Sentry from '@sentry/react'
import { SENTRY_SEVERITY } from 'src/utils/sentry'
import { cmdTypeLabel, WATCH_CMD_TYPES } from 'src/utils/sentry/api'
import CmdType from 'src/service/constants'

type FlowPhase = 'request' | 'response'

type FlowBreadcrumbData = {
  cmdType?: string
  errCode?: string
  errMsg?: string
}

function flowLabel(cmdType: string): string {
  for (const [name, value] of Object.entries(CmdType)) {
    if (value === cmdType) return name
  }
  return cmdType
}

export function addApiBreadcrumb(phase: FlowPhase, data: FlowBreadcrumbData) {
  const cmdType = data?.cmdType
  if (!cmdType || !WATCH_CMD_TYPES.has(cmdType)) return

  Sentry.addBreadcrumb({
    category: 'flow',
    message: `${flowLabel(cmdType)}[${phase}]`,
    level: phase === 'response' ? SENTRY_SEVERITY.Warning : SENTRY_SEVERITY.Info,
    data: {
      cmdType: cmdTypeLabel(cmdType),
      path: window.location.pathname,
      phase,
      ...data,
    },
  })
}
